import { SmsEspAccount } from 'modules/graphql/types';
import { Modal, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS, ModalFooter } from 'ui/modal';
import { VerificationProfilesTable } from './VerificationProfilesTable';
import { useModalsContext } from '../../../../contexts';

const TEXT = {
  ID: 'sms-verification-profile-modal',
};

type Props = {
  espAccount: SmsEspAccount;
  headerText: string;
};

export const VerificationProfileModal = ({ espAccount, headerText }: Props) => {
  const { hideModal } = useModalsContext();
  return (
    <Modal
      id={TEXT.ID}
      isModalOpen={true}
      onClose={hideModal}
      size={MODAL_SIZES.MEDIUM}
      variant={MODAL_VARIANTS.DEFAULT}
    >
      <ModalHeader>{headerText}</ModalHeader>
      <ModalBody>
        <VerificationProfilesTable espAccount={espAccount} />
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};
